import { createSlice } from "@reduxjs/toolkit";
import { vendorCheckOrCreate } from "../CommunityAPI/communityApi";

const vendorCheckOrCreateSlice = createSlice({
  name: "vendorCheckOrCreate",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(vendorCheckOrCreate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(vendorCheckOrCreate.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(vendorCheckOrCreate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendorCheckOrCreateSlice.reducer;
